import { Api } from '@blink/components';

export type Token = {
    id?: number;
    apy?: string;
    totalDeposited?: string;
    address?: string;
    name: string;
    symbol: string;
    balance?: string;
    decimals: number;
    agreementAddress?: string;
    userBalance?: string;
    poolBalance?: string;
};

export enum ACCOUNT_STATUS {
    OPENED = 'opened',
    SUSPENDED = 'suspended',
}

export enum ROLE {
    INVESTOR = 'investor',
    CURATOR = 'curator',
}

export type MarginAccount = {
    address: string;
    status: ACCOUNT_STATUS;
    owner: string;
    leverage: {
        id: number;
        address: string;
        name: string;
        symbol: string;
        decimals: number;
        amount: string;
    };
    openedAt: string;
    agreementAddress: string;
};

export type StressTestMatrix = {
    address: string;
    percent: string;
    priceModel: string;
    priceProvider: string;
    symbol: string;
};

export type VaultBasic = {
    address: string;
    curator: string;
    role: ROLE;
    id: number;
    leverageTokenId: number;
    netApy: string;
    title: string;
    totalSupply?: string;
    performanceFee: string;
};

export type VaultDetails = {
    address: string;
    leverageTokenId: number;
    title: string;
    description: string;
    lenders?: string[];
    borrowers?: string[];
    liquidationFee?: string;
    liquidationThreshold?: string;
    marginCallThreshold?: string;
    stressTestMatrix: StressTestMatrix[];
    netapy?: string;
    apy: string;
    icon?: string;
};

export interface MetadataVault {
    leverage: string;
    apy: number;
    totalDepositThreshold: bigint;
    collaterals: string[];
    liquidityProvider: string[];
    assetManagers: string[];
}

export type Vault = VaultBasic &
    VaultDetails & {
        totalDepositThreshold?: string;
        totalDeposited?: string;
        description?: string;
        leverage: Token;
        collaterals: any[];
        investors?: string[];
        curators?: string[];
        tokens?: string[];
        totalPosition?: string;
        poolBalance?: string;
        withdrawable?: string;
        interestAccrued?: string;
        interestClaimable?: string;
        totalBorrowed?: string;
        poolUtilization?: string;
        suspended?: boolean;
        noWalletInfo?: boolean;
        errorContract?: boolean;
    };

export const getTokens = () => {
    return Api.getResponse<Token[]>(`${Api.REACT_APP_ANALYTICS_HTTP_URL}/v1/tokens`);
};

export const getVaults = (withoutCache?: boolean) => {
    return Api.getResponse<VaultBasic[]>(
        `${Api.ARKIS_PORTAL_HTTP_URL}/v1/vaults`,
        undefined,
        withoutCache,
    );
};

export const getVaultDetails = (address: string, withoutCache?: boolean) => {
    return Api.getResponse<VaultDetails>(
        `${Api.ARKIS_PORTAL_HTTP_URL}/v1/vaults/${address}`,
        undefined,
        withoutCache,
    );
};

export const getMarginAccounts = (address: string, withoutCache?: boolean) => {
    return Api.getResponse<MarginAccount[]>(
        `${Api.ARKIS_PORTAL_HTTP_URL}/v1/margin-accounts/?owner=${address}`,
        undefined,
        withoutCache,
    );
};
